import { Component, Input } from '@angular/core';
import {
    ActionHeaderService,
    AumBreadcrumbComponentItem,
    AumGlobalAction,
    IAumGlobalActionEvent,
} from '@modeso/aumico-lib-core-fe';

@Component({
    selector: 'ham-page-header',
    template: `
        <div class="header-container">
            <div class="breadcrumb" *ngIf="breadcrumbs.length > 0">
                <span
                    *ngFor="let item of breadcrumbs; let last = last"
                    [routerLink]="item.routerLink"
                    [ngClass]="{ 'breadcrumb-bold ': item.isActive ? true : false }"
                >
                    <span *ngIf="!item.translated">
                        {{ item.displayName | i18next }}
                    </span>
                    <span *ngIf="item.translated">
                        {{ item.displayName }}
                    </span>
                    <span
                        *ngIf="!last"
                        class="arrow-icon"
                        hamIconShapes
                        icon="assets/hamIcons/chevron-right.svg"
                        [variant]="'transparent'"
                        [size]="'xs'"
                    >
                    </span>
                </span>
            </div>
            <div class="header">
                <span
                    *ngIf="hasBackButton"
                    hamIconShapes
                    icon="assets/hamIcons/arrow-left-outline.svg"
                    [variant]="'grey-border'"
                    [size]="'header'"
                    class="chevron-icon"
                    [routerLink]="backButtonRoute"
                    (keydown.enter)="onBack()"
                    (click)="onBack()"
                >
                </span>
                <h1 class="header-title">{{ title | i18next }}</h1>
            </div>
        </div>
    `,
    styleUrls: ['./ham-page-header.component.scss'],
})
export class HamPageHeaderComponent {
    @Input() title: string = '';
    @Input() breadcrumbs: AumBreadcrumbComponentItem[] = [];
    @Input() backButtonRoute?: string;
    @Input() hasBackButton = true;

    constructor(private actionHeaderService: ActionHeaderService) {}

    public onBack(): void {
        if (this.backButtonRoute === undefined) {
            const event: IAumGlobalActionEvent = {
                action: AumGlobalAction.GOBACK,
                value: true,
            };
            this.actionHeaderService.onAction(event);
        }
    }
}
